import React from 'react'
import { useLocation, useNavigate, Link } from 'react-router-dom'
import { CheckCircleIcon } from '@heroicons/react/24/solid'

const BidSuccessPage = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const bidId = location.state?.bidId

  const handleViewBidClick = () => {
    if (bidId) {
      navigate('/bids')
    } else {
      throw new Error(
        'BidSuccessPage: No Bid ID found in location state. This is a required property for this page.'
      )
    }
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-neutral-200-50 p-4">
      <div className="bg-background p-8 rounded-lg shadow-md text-center max-w-md w-full">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-green-100 mb-6">
          <CheckCircleIcon className="h-10 w-10 text-green-600" aria-hidden="true" />
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-3">Bid Submitted Successful</h2>
        <p className="text-base text-gray-600 mb-8">
          Your bid request has been successfully submitted. You'll get a notification once the
          retailer responds. Thank you for using Product Bidding.
        </p>
        <button
          onClick={handleViewBidClick}
          disabled={!bidId}
          className="w-full px-6 py-3 text-lg font-medium text-white capitalize bg-gradient-to-r from-secondary-700 to-secondary-500 rounded-lg hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-secondary-600 transition-opacity shadow disabled:opacity-50 disabled:cursor-not-allowed"
        >
          View Product Bid
        </button>
      </div>
    </div>
  )
}

export default BidSuccessPage
